// noinspection JSUnresolvedReference

import React, {useEffect, useState} from "react";
import useAuthorityConfiguration from "../../../../../api/utilities/useAuthorityConfiguration.js";
import {ErpCalculationApi} from "../../../../../api/authority/generated/index";
import {useTranslation} from "react-i18next";
import LoadingComponent from "../../../../../components/LoadingComponent.jsx";
import DoughnutChart from "../../../../../mosaic/charts/DoughnutChart.jsx";
import {getContrastBackgroundColors, getContrastBackgroundHoverColors} from "../../../../../utils/graphColors.js";

export default function DailyShippingPerformance({title, day, project}) {

    let {t} = useTranslation();

    let [data, setData] = useState(null);

    let authorityConfiguration = useAuthorityConfiguration();

    useEffect(() => {
            new ErpCalculationApi(authorityConfiguration)
                .dailyShippingPerformance({
                    projectId: project.id,
                    dayInput: {
                        day: day.format('YYYY-MM-DD')
                    },
                })
                .then(setData);
        },

        [day.format('YYYY-MM-DD'), project.id]
    );

    let [labels, setLabels] = useState([]);
    let [dataSource, setDataSource] = useState(null);


    useEffect(() => {

        let newLabels = [];
        let newDataSource = [];

        // noinspection JSUnresolvedReference
        for (let shipping of data?.shippings ?? []) {
            if (shipping.remoteId === 'default') {
                shipping.name = t('orders.unresolved-shipping');
            }

            newLabels.push(shipping.name);
            newDataSource.push(shipping.amount);
        }

        setLabels(newLabels);
        setDataSource(newDataSource);

    }, [data]);

    return (
        <LoadingComponent
            loading={data === null || dataSource === null}
            className={'col-span-12 sm:col-span-2 text-slate-600 dark:text-slate-400'}
        >
            <div
                className="comp__roundedBox inline-flex flex-col w-full rounded-sm text-sm bg-white dark:bg-slate-800 shadow-lg border border-slate-200 dark:border-slate-700">
                <div
                    className={'px-5 py-4 border-b border-slate-100 dark:border-slate-700 flex items-center'}>
                    <h2 className={'font-semibold text-slate-800 dark:text-slate-100'}>
                        {title}
                    </h2>
                </div>
                {dataSource !== null && data !== null &&
                    <DoughnutChart data={{
                        labels: labels,
                        datasets: [
                            {
                                data: dataSource,
                                backgroundColor: getContrastBackgroundColors(),
                                hoverBackgroundColor: getContrastBackgroundHoverColors(),
                                borderWidth: 0,
                            },
                        ],
                    }} height={200}/>
                }
            </div>
        </LoadingComponent>
    );
}
